// extracted by mini-css-extract-plugin
export default {"imageSequence":"styles_imageSequence__x7ePT","image":"styles_image__HD5rk","active":"styles_active__DdJzz"};